<div id="extr-page">
<router-outlet></router-outlet>
</div>
